import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import useStore from "../store/store";
import billService from "../services/bill";
import {
	Text,
	Heading,
	Button,
	FormatNumeric,
	ArrowDownChip,
} from "../controls";

function AddBill({ toggleDrawer, reload }) {
	let [title, setTitle] = useState("");
	let [product, setProduct] = useState("");
	let [count, setCount] = useState(0);
	let [weightPerBag, setWeightPerBag] = useState(0);
	let [rate, setRate] = useState(0);

	const navigate = useNavigate();
	const { token, setErrorMessage, setSuccessMessage, setIsLoading, currObj } =
		useStore((state) => state);

	useEffect(() => {
		if (currObj) {
			setTitle(currObj.title);
			setProduct(currObj.product);
			setCount(currObj.count);
			setWeightPerBag(currObj.weightPerBag);
			setRate(currObj.rate);
		}
	}, [currObj]);

	const createBill = (more) => {
		window.location.href.includes("id=") ? add(more) : create();
	};

	const create = () => {
		let totalWeight = count * weightPerBag;
		let price = ((count * weightPerBag) / 40) * rate;
		let data = {
			title,
			arr: [{ product, count, weightPerBag, totalWeight, rate, price }],
		};
		billService.create(token, data).then((r) => {
			if (r.error) {
				setErrorMessage(r.error);
				setIsLoading(false);
				return;
			}
			if (r.data) {
				setSuccessMessage("Bill added successfully");
				clearForm();
				reload();
				toggleDrawer();
				navigate(`/bill-details?id=${r.data._id}`);
			}
		});
	};

	const add = (more) => {
		let totalWeight = count * weightPerBag;
		let price = ((count * weightPerBag) / 40) * rate;
		let id = window.location.href.split("id=").pop();
		let data = { product, count, weightPerBag, totalWeight, rate, price };
		billService.add(token, id, data).then((r) => {
			if (r.error) {
				setErrorMessage(r.error);
				setIsLoading(false);
				return;
			}
			if (r.data) {
				setSuccessMessage("Entry added successfully");
				clearForm();
				if (more === false) {
					reload();
					toggleDrawer();
				}
			}
		});
	};

	const clearForm = () => {
		setTitle("");
		setCount("");
		setRate("");
	};

	return (
		<>
			<Container sx={{ overflow: "auto" }}>
				<Heading text="Add Bill" variant="h6" />
				{!window.location.href.includes("id=") && (
					<Text
						label="Customer Name"
						value={title}
						onChange={setTitle}
					/>
				)}
				<Text
					label="Product Name"
					value={product}
					onChange={setProduct}
				/>
				<FormatNumeric
					label="Number of Bags"
					value={count}
					onChange={setCount}
				/>
				<FormatNumeric
					label="Weight per Bag"
					value={weightPerBag}
					onChange={setWeightPerBag}
				/>
				<FormatNumeric
					label="Rate per Mann (40kg)"
					value={rate}
					onChange={setRate}
				/>
				<Button
					icon={<ion-icon name="add-circle-outline"></ion-icon>}
					onClick={() => createBill(false)}
					text="Create"
				/>
				{window.location.href.includes("id=") && (
					<Button
						icon={<ion-icon name="add-circle-outline"></ion-icon>}
						onClick={() => createBill(true)}
						text="Create & Add more"
					/>
				)}
				<ArrowDownChip
					onClick={() => {
						clearForm();
						reload();
						toggleDrawer();
					}}
				/>
			</Container>
		</>
	);
}

export default AddBill;
